import WorkContentModal from "@/components/shared/WorkContentModal";
import ConfirmModal from "@/components/shared/ConfirmModal";
import DashboardServices from "@/services/DashboardServices";
import { finOrderIndex } from "@/services/GlobalServices";
import ShowRevisionServices from "@/services/ShowRevisionServices";
import DashboardConstants from "@/store/constants/dashboardRecords";
import TrashIcon from "@/components/shared/TrashIcon"
import DashboardInternalData from "@/internalData/Dashboard"
import GlobalConstants from "@/store/constants/global"
export default {
  name: 'WorkRecordsTable',
  components: {
    WorkContentModal,
    ConfirmModal,
    TrashIcon,
  },
  model: {},
  data() {
    return {
      fields: DashboardInternalData.workRecords.titleHeader,
      useOfFireFields: {
        "notUse": "〇",
        "useFire": "◎"
      },
      confirmFields: {
        "confirm": '✕',
        "notConfirm": '〇'
      },
      safetyInstruction: {
        "safety": this.$t("table.safetyInstruction.safety"),
        "quanlity": this.$t("table.safetyInstruction.quanlity"),
        "enviroment": this.$t("table.safetyInstruction.enviroment")
      },
      isCreate: true
    };
  },
  methods: {
    // 編集中の値と初期値を比較してスタイルを決定
    getFieldStyle(workRecordOrder, fieldPath) {
      const currentRevisions = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions];
      const initialRevisions = this.$store.getters[DashboardConstants.GETTERS.getInitRevisionsState];
      
      // workRecordを見つける
      const currentWorkRecord = currentRevisions.workRecords.find(wr => wr.order === workRecordOrder);
      const initialWorkRecord = initialRevisions.workRecords.find(wr => wr.order === workRecordOrder);
      
      if (!currentWorkRecord || !initialWorkRecord) {
        return 'history-color-black'; // デフォルト
      }
      
      // 該当フィールドの値を取得
      const currentValue = this.$_.get(currentWorkRecord, fieldPath, '');
      const initialValue = this.$_.get(initialWorkRecord, fieldPath, '');
      
      // 比較して色を決定
      if (currentValue === initialValue) {
        return 'history-color-black'; // 変更なし
      } else {
        return 'history-color-orange'; // 変更あり
      }
    },
    updateStatusWordRecord(status){
      this.isCreate = (status == "CREATE") ? true : false
    },
    createWorkContent() {
      this.updateStatusWordRecord("CREATE")
      this.$store.commit(DashboardConstants.COMMIT.setTempWorkRecord, {
        tempWorkRecord: DashboardServices.defaultWorkRecord()
      });
      this.$bvModal.show("work-content-modal");
    },
    showConfirmModal(orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "workRecords", orderId: orderId });
    },
    editWorkContent(item) {
      if (item.shadowOrder == -1) {return}
      const workRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords;
      // originalRowIdがある場合はそれで検索、なければorderで検索（後方互換性）
      const workRecord = workRecords.find((element) => {
        const elementOriginalRowId = element.originalRowId || element.record?.originalRowId;
        if (elementOriginalRowId && item.shadowOrder) {
          return elementOriginalRowId === item.shadowOrder;
        }
        return element.order == item.shadowOrder;
      });
      this.updateStatusWordRecord("UPDATE")
      this.$store.commit(DashboardConstants.COMMIT.setTempWorkRecord, { tempWorkRecord: this.$_.cloneDeep(workRecord) });
      this.$bvModal.show("work-content-modal");
    },
    isFirstItemWorkDialog(index) {
      return index == 0;
    },
    isLatestItemWorkDialog(order) {
      const workRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords;
      const hasNoOrderPosition = workRecords.find((workRecord) => {workRecord.orderPosition == undefined })
      let isOrderPositionNull = (hasNoOrderPosition != undefined)
      let latestOrder = isOrderPositionNull ? this.$_.last(workRecords) :
                                              this.$_.maxBy(workRecords, (n) => n.orderPosition)
      return order == latestOrder.order;
    },
    changePositionWorkDialogUp(shadowOrder, currentlyOrderPosition) {
      // shadowOrderから実際のorderを取得
      const order = this.getOrderFromShadowOrder(shadowOrder);
      this.checkOrderPositionID(order)
      let {workRecords, index} = this.getWordRecordsAndIndexCurrentOrder(order)
      let positionTarget =  workRecords[index - 1].orderPosition

      this.setPosition(index, positionTarget)
      this.setPosition(index-1, currentlyOrderPosition)
    },
    changePositionWorkDialogDown(shadowOrder, currentlyOrderPosition) {
      // shadowOrderから実際のorderを取得
      const order = this.getOrderFromShadowOrder(shadowOrder);
      this.checkOrderPositionID(order)
      let {workRecords, index} = this.getWordRecordsAndIndexCurrentOrder(order)
      let nextOrderPosition =  workRecords[index + 1].orderPosition

      this.setPosition(index, nextOrderPosition)
      this.setPosition(index+1, currentlyOrderPosition)
    },
    checkOrderPositionID(order){
      let {workRecords, index} = this.getWordRecordsAndIndexCurrentOrder(order)
      let orderPosition = workRecords[index].orderPosition;
      if(orderPosition == undefined){
        this.$store.commit(DashboardConstants.COMMIT.changePositionWorkDialog, { index: index, orderPosition: workRecords[index].order });
      }
    },
    setPosition(index, positionID){
      this.$store.commit(DashboardConstants.COMMIT.changePositionWorkDialog, { index: index, orderPosition: positionID});
    },
    getOrderFromShadowOrder(shadowOrder) {
      const workRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords;
      const workRecord = workRecords.find((element) => {
        const elementOriginalRowId = element.originalRowId || element.record?.originalRowId;
        if (elementOriginalRowId && shadowOrder) {
          return elementOriginalRowId === shadowOrder;
        }
        return element.order == shadowOrder;
      });
      return workRecord ? workRecord.order : shadowOrder;
    },
    getWordRecordsAndIndexCurrentOrder(order){
      let workRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords;
      let index = parseInt(finOrderIndex(workRecords, order));
      return {workRecords, index}
    },
    isImageBaseURL(sign){
      return DashboardServices.isImageBaseURL(sign)
    },
    createObjectUrl(presignedUrl) {
      // presignedUrlがnullまたは空文字列の場合は空文字列を返す
      if (!presignedUrl) return "";

      // presignedUrlがオブジェクトの場合
      if (typeof presignedUrl === "object") {
        // presignedUrlプロパティがある場合はそれを使用
        if (presignedUrl.presignedUrl) {
          return presignedUrl.presignedUrl;
        }
        // objectKeyプロパティがある場合はそれを使用
        if (presignedUrl.objectKey) {
          return presignedUrl.objectKey;
        }
      }

      // 文字列の場合
      if (typeof presignedUrl === "string") {
        // 既にURLの形式になっている場合はそのまま返す
        const urlPattern = /^(https?:\/\/|blob:|data:)/i;
        if (urlPattern.test(presignedUrl)) {
          return presignedUrl;
        }

        // 画像ファイル拡張子を持つ場合
        const imageExtensions = [
          ".png",
          ".jpg",
          ".jpeg",
          ".gif",
          ".bmp",
          ".webp",
          ".svg",
        ];
        for (const ext of imageExtensions) {
          if (presignedUrl.toLowerCase().endsWith(ext)) {
            return presignedUrl;
          }
        }
      }

      return presignedUrl;
    },
    createTempWorkRecord(workRecordsOrder){
      let colorControlTemplate = ShowRevisionServices.createTemplate("workRecords");
      let wordRecordTemplate = ShowRevisionServices.createTemplatePreviousValue("workRecords");
      return Object.assign({
        order: -1,
        shadowOrder: workRecordsOrder,
        qualificatedResponsible: {},
        equipments: {},
        safetyInstructions: {},
        numberOfPeople: {}},
        {style: colorControlTemplate},
        {previousItem: wordRecordTemplate});
    }
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    getDiaryPrevious() {
      let workRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords;
      let results = [];
      if (!workRecords) {return;}

      workRecords.forEach(element => {
        let equipmentLength = element.equipments.length,
            qualifiedResponsibleLength = element.qualificatedResponsible.length,
            safetyInstructionLength = element.safetyInstructions.length;
        let maxLength = this.$_.max([equipmentLength, qualifiedResponsibleLength, safetyInstructionLength]);
        // originalRowIdがある場合はそれを使用、なければorderを使用（後方互換性）
        const shadowOrderValue = element.originalRowId || element.record?.originalRowId || element.order;
        let workRecord = Object.assign({ shadowOrder: shadowOrderValue }, element); //shadowOrder Use to show/hide move position element

        (equipmentLength >= 1) && Object.assign(workRecord, { equipments: element.equipments[0]});
        (qualifiedResponsibleLength >= 1) && Object.assign(workRecord, { qualificatedResponsible: element.qualificatedResponsible[0], });
        (safetyInstructionLength >= 1) && Object.assign(workRecord, { safetyInstructions: element.safetyInstructions[0], });
        results.push(workRecord);

        //add entry workRecords when (equipments, safetyInstructions) is array
        for (let i = 1; i <= maxLength - 1; i++) {
          let workRecordTemp = this.createTempWorkRecord(element.order);
          (qualifiedResponsibleLength - 1 >= i) && Object.assign(workRecordTemp, { qualificatedResponsible: element.qualificatedResponsible[i]});
          (equipmentLength - 1 >= i) && Object.assign(workRecordTemp, { equipments: element.equipments[i]});
          (safetyInstructionLength - 1 >= i) && Object.assign(workRecordTemp, { safetyInstructions: element.safetyInstructions[i]});
          results.push(workRecordTemp);
        }
      });
      return results;
    }
  }
};
